import { render, staticRenderFns } from "./JingTaiLabelDialog.vue?vue&type=template&id=dfe3214c&scoped=true"
import script from "./JingTaiLabelDialog.vue?vue&type=script&lang=js"
export * from "./JingTaiLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./JingTaiLabelDialog.vue?vue&type=style&index=0&id=dfe3214c&prod&scoped=true&lang=css"
import style1 from "./JingTaiLabelDialog.vue?vue&type=style&index=1&id=dfe3214c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe3214c",
  null
  
)

export default component.exports